// Third Party Lib
import { GetObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";

// Config
import { APP_CONFIG } from "../../../config";

const { AWS_SDK_CONFIG } = APP_CONFIG;

const s3 = new S3Client({
  credentials: AWS_SDK_CONFIG.credential,
  region: AWS_SDK_CONFIG.credential.region,
  // Fix CRC32 issue, when uploading big-sized files
  forcePathStyle: false,
  defaultsMode: "standard", 
  useArnRegion: false,
  retryMode: "standard",
  requestChecksumCalculation: "WHEN_REQUIRED", 
  responseChecksumValidation: "WHEN_REQUIRED"

});

export const uploadS3 = ({ bucket, key, file, acl = "public-read" }) => {
  const uploadParameters = {
    Bucket: bucket,
    Key: key,
    ContentType: file.type,
    Body: file,
    ACL: acl,
  };

  const S3UploadNew = new Upload({
    client: s3,
    params: uploadParameters,
    leavePartsOnError: false,

  });

  return S3UploadNew;
};

export const S3GetObject = (bucket, key) =>
  s3
    .send(
      new GetObjectCommand({
        Bucket: bucket,
        Key: key,
      })
    )
    .then((data) => data);
